import {mapActions, mapGetters, mapState} from 'vuex';
import IntervalProgressBar from '../modules/dro/components/IntervalProgressBar';
import Constants from '../modules/dro/Constants';
import UuidGenerator from '@/common/uuid/UuidGenerator';

export const currentIntervalForm = {
  data() {
    return {
      form: {
        intervalDurationValue: null,
        intervalDurationUnitId: null,
      },
      isLoaded: false,
    };
  },

  components: {IntervalProgressBar},
  computed: {
    ...mapState('dro/session', [
      'settings',
      'currentInterval',
      'intervals',
      'shouldStartIntervalAutomatically',
      'uuid',
    ]),
    ...mapGetters('dro/session', [
      'intervalDuration',
      'isIntervalStarted',
    ]),
  },
  methods: {
    ...mapActions('dro/session', [
      'setIntervalDuration',
      'setCurrentInterval',
      'addInterval',
      'setCurrentIntervalTime',
      'setCurrentIntervalBehaviourHappenedAt',
      'setFinishedAt',
      'setCurrentInterval',
      'setShouldStartIntervalAutomatically',
      'onBehaviourHappened',
      'startTimer',
      'resetTimer',
    ]),
    ...mapActions('appeals', [
      'setEntity',
    ]),
    ...mapGetters('mobile', [
      'isMobile',
    ]),
    async startSession() {
      let isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }
      this.setIntervalDuration({
        value: this.form.intervalDurationValue,
        unitId: this.form.intervalDurationUnitId,
      });
      if (!this.isIntervalStarted) {
        let index = this.intervals.length + 1;
        let duration = this.intervalDuration;
        this.setCurrentInterval({index, duration});
      }
      this.startTimer();
      this.isLoaded = true;
    },
    finishSession() {
      this.resetTimer();
      this.setCurrentInterval();
      this.saveSession();
      this.setEntity({});
    },
    saveSession() {
      this.setFinishedAt(Math.round((new Date()).getTime() / 1000));
      this.$emit('save-session');
    },
    fillFormData() {
      this.form.intervalDurationValue = this.settings.intervalDurationValue;
      this.form.intervalDurationUnitId = this.settings.intervalDurationUnitId;
    },
    init() {
      if (this.shouldStartIntervalAutomatically) {
        this.setShouldStartIntervalAutomatically(false);
        this.startSession();
      } else {
        this.isLoaded = true;
      }
      let entity = {
        id: this.uuid,
        type: Constants.ENTITY_TYPE,
      };
      this.setEntity(entity);
      console.info(entity)
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/currentIntervalForm.js